import styled from 'styled-components'

export const ComposerBoxStyled = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${(props) => props.theme.space.small};
  padding: ${(props) => props.theme.typography.pxToRem(12)};
  border: 1px solid ${(props) => props.theme.colors.content.secondaryBorder};
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
`

export const ComposerTextareaStyled = styled.textarea`
  flex: 1;
  min-height: ${(props) => props.theme.typography.pxToRem(72)};
  resize: none;
  border: none;
  outline: none;
  background: transparent;
  font: inherit;
  color: inherit;
`

export const SendErrorTextStyled = styled.span`
  font-size: ${(props) => props.theme.typography.pxToRem(13)};
  color: ${(props) => props.theme.colors.error};
`

export const ComposerSendButtonStyled = styled.button`
  min-width: ${(props) => props.theme.typography.pxToRem(32)};
  height: ${(props) => props.theme.typography.pxToRem(32)};
  padding: 0;
  border: none;
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.theme.colors.button.primary.background.default};
  color: ${(props) => props.theme.colors.button.primary.content.default};
  cursor: pointer;

  &:disabled {
    background-color: ${(props) =>
      props.theme.colors.button.primary.background.disabled};
    color: ${(props) => props.theme.colors.button.primary.content.default};
    cursor: default;
  }

  &:hover:not(:disabled) {
    background-color: ${(props) =>
      props.theme.colors.button.primary.background.hover};
  }
`
